<script>
import { mapGetters } from 'vuex';
import { Field } from 'vee-validate';
import { directive } from 'vue3-click-away';
import VSelect from '@/components/Common/VSelect';
import VTextArea from '@/components/Common/VTextArea';
import VSelectTime from '@/components/Common/VSelectTime';
import VInputDate from '@/components/Common/VInputDate';
import { ref } from 'vue';
import { format } from 'date-fns';
import _parseISO from 'date-fns/parseISO';
import axios from 'axios';
import { Calendar } from 'v-calendar';
import VInput from '@/components/Common/VInput';
import RecomendationCard from './RecomendationCard.vue';

import 'v-calendar/style.css';

export default {
  name: 'SecondStep',
  components: {
    VInput,
    VSelect,
    VSelectTime,
    VTextArea,
    VInputDate,
    RecomendationCard,
    Calendar,
    VeeField: Field,
  },
  directives: {
    ClickAway: directive,
  },
  props: {
    form: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      visibleCal: false,
      calendarValue: '',
      activeTab: false,
      dealerId: '',
      typeRepair: 'diag',
      activeDays: [],
      RecordingDateList: [],
      times: [],
    };
  },
  created() {
    window.VueCalendarLang = () => {
      let text = {
        daysOfWeek: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
        limit: 'Достигнут лимит ({{limit}} макс. элементов).',
        loading: 'Загрузка...',
        minLength: 'Мин. длина',
        months: [
          'Январь',
          'Февраль',
          'Март',
          'Апрель',
          'Май',
          'Июнь',
          'Июль',
          'Август',
          'Сентябрь',
          'Октябрь',
          'Ноябрь',
          'Декабрь',
        ],
        notSelected: 'Ничего не выбрано',
        required: 'Обязательно',
        search: 'Поиск',
      };
      return text;
    };
  },
  computed: {
    ...mapGetters({
      services: 'Service/services',
      dealers: 'Service/dealers',
      fetching: 'Service/fetching',
      recomendations: 'Service/recomendations',
    }),
  },
  watch: {
    form: {
      handler(value) {
        this.$emit('update-form', value);
      },
      deep: true,
    },
    'form.service'(val) {
      this.typeRepair = val.type_repair;
      this.times = [];
      this.form.time = [];
      this.form.date = null;
      this.calendarValue = '';
      this.getAvailableDays();
    },
    'form.dealer'(value) {
      this.dealerId = value.id;
      this.calendarValue = '';
      this.form.date = null;
      this.form.service = null;
    },
    'form.date'(val) {
      this.times = [];
      this.form.time = [];
      this.getAvailableTimeSlots();
      const refDays = ref(this.RecordingDateList);
      const refCurrentDay = ref(val.selected);
      const refActiveDays = ref([
        {
          highlight: {
            class: 'green',
            fillMode: 'solid',
          },
          dates: refDays.value,
        },
        {
          highlight: {
            class: 'red',
            fillMode: 'solid',
          },
          dates: refCurrentDay.value,
        },
      ]);
      this.activeDays = refActiveDays;
    },
  },
  methods: {
    showCal() {
      this.visibleCal = true;
    },
    hideCal() {
      this.visibleCal = false;
    },
    onDayClick(data) {
      this.calendarValue = data.id;
      const day =
        String(data.date.getDate()).length === 1
          ? '0' + data.date.getDate()
          : data.date.getDate();
      const monthOld = data.date.getMonth() + 1;
      const month = String(monthOld).length === 1 ? '0' + monthOld : monthOld;
      const date = day + '.' + month + '.' + data.date.getFullYear();

      const params = {
        date: {
          full_date: data.date,
          name: date,
          selected: data.id,
        },
      };

      this.$emit('update-form', params);
      this.visibleCal = false;
    },
    getAvailableDays() {
      const currentDate = new Date().toISOString().slice(0, 10);
      const nextMonth = new Date(currentDate);
      nextMonth.setMonth(nextMonth.getMonth() + 1);
      const bodyFormData = new FormData();
      bodyFormData.append('dateAt', currentDate);
      bodyFormData.append('dateTo', nextMonth.toISOString().slice(0, 10));
      bodyFormData.append('dealerId', this.dealerId);
      bodyFormData.append('typeRepair', this.typeRepair);

      return axios
        .post('/api/terravtoapi/getfreedatesforperiod/', bodyFormData, {})
        .then(data => {
          const refDays = ref(data.data.RecordingDateList);
          const refActiveDays = ref([
            {
              highlight: {
                class: 'green',
                fillMode: 'solid',
              },
              dates: refDays.value,
            },
          ]);
          this.RecordingDateList = data.data.RecordingDateList;
          this.activeDays = refActiveDays;
        })
        .catch(error => {
          return Promise.reject({
            error,
          });
        });
    },
    getAvailableTimeSlots() {
      const bodyFormData = new FormData();
      bodyFormData.append('dateAt', this.calendarValue);
      bodyFormData.append('typeRepair', this.typeRepair);
      bodyFormData.append('dealerId', this.dealerId);
      return axios
        .post('/api/terravtoapi/gettimeslotsfordate/', bodyFormData, {})
        .then(response => {
          const data = response.data.RecordingList;
          const getTime = date => {
            return format(_parseISO(date), 'HH:mm');
          };
          const prepDate = data.map((e, i) => {
            return {
              id: i + 1,
              name: `${getTime(e[`Recording`].dateStartAt)} - ${getTime(e[`Recording`].dateEndAt)}`,
            };
          });
          this.times = prepDate;
        })
        .catch(error => {
          return Promise.reject({
            error,
          });
        });
    },
  },
};
</script>

<template>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 sm:col-span-2 lg:grid-cols-4 lg:col-span-4 w-full gap-x-5 gap-y-5"
  >
    <vee-field v-slot="{ handleChange, errorMessage }" name="dealer">
      <v-select
        v-model="form.dealer"
        :options="dealers"
        placeholder="Выберите удобный ДЦ"
        inscription="ДЦ*"
        theme="white"
        :error="errorMessage"
        @update:modelValue="handleChange"
      />
    </vee-field>

    <vee-field v-slot="{ handleChange, errorMessage }" name="service">
      <v-select
        v-model="form.service"
        :options="services"
        placeholder="Выберите услугу"
        inscription="Услуга*"
        theme="white"
        :error="errorMessage"
        @update:modelValue="handleChange"
        :disabled="form.dealer === null || form.dealer?.exception"
      />
    </vee-field>

    <div v-click-away="hideCal" class="relative">
      <vee-field v-slot="{ handleChange, errorMessage }" name="date">
        <v-input-date
          :modelValue="form?.date?.name ? form.date.name : ''"
          :readonly="true"
          placeholder="__.__.____"
          inscription="Желаемая дата*"
          theme="white"
          :error="errorMessage"
          @click="showCal"
          @update:modelValue="handleChange"
          :disabled="form.service === null || form.service?.exception"
        />
      </vee-field>
      <div v-show="visibleCal" class="absolute z-50 grid grid-cols-1 mb-5">
        <Calendar
          v-model="calendarValue"
          :attributes="activeDays"
          :min-date="new Date()"
          @dayclick="onDayClick"
          locale="ru"
        >
        </Calendar>
      </div>
    </div>

    <vee-field v-slot="{ handleChange, errorMessage }" name="time">
      <v-select-time
        v-model="form.time"
        :options="times"
        placeholder="Выберите время"
        inscription="Желаемое время"
        theme="white"
        :error="errorMessage"
        @update:modelValue="handleChange"
        :disabled="form.date === null || form.date?.exception"
      />
    </vee-field>
  </div>
  <div
    class="relative w-full flex-wrap lg:flex col-auto sm:w-full lg:grid-cols-2 lg:col-span-4 mt-[10px] mx-auto justify-center text-gray-600"
  >
    <vee-field v-slot="{ handleChange, errorMessage }" name="comment">
      <v-text-area
        v-model="form.comment"
        placeholder="Коментарий"
        inscription="Коментарий"
        theme="white"
        name="comment"
        resize="none"
        :error="errorMessage"
        @update:modelValue="handleChange"
      />
    </vee-field>
    <div
      v-if="recomendations.length"
      class="swiper-recommendations w-full overflow-hidden"
    >
      <div class="max-w-[500px] my-[20px] flex flex-col">
        <p class="font-fira font-medium my-[10px]">
          Рекомендации для ваших авто
        </p>
        <p class="text-xs">
          Мы подготовили рекомендации по работам для других ваших автомоблей. Вы
          можете выбрать необходимые, а мы выполним их на сервисе:
        </p>
      </div>
      <div class="swiper-wrapper">
        <div
          class="swiper-slide flex w-full mt-[20px]"
          v-for="(item, index) in recomendations"
          :key="index"
        >
          <recomendation-card :key="index" :form="form" :item="item" />
        </div>
      </div>
    </div>
    <div
      v-if="recomendations.length > 1"
      class="flex swiper-rec-small-button-next mt-[15px]"
    >
      Следующее авто >
    </div>
  </div>
</template>

<style>
.flex .relative .h-full {
  width: 100%;
}
.vc-day-content {
  pointer-events: none !important;
  color: grey !important;
}

textarea {
  resize: none;
}

.vc-day-content.vc-blue,
.vc-red {
  pointer-events: unset !important;
  color: white !important;
  border-radius: 7px !important;
}
.green {
  background-color: #95ca51;
}

.red {
  background-color: #ec2830 !important;
}

.vc-day-content {
  font-feature-settings: normal !important;
  font-family: 'FiraSans', Arial, sans-serif !important;
}

.vc-highlight-bg-solid.green,
.vc-highlight-bg-solid.red {
  border-radius: 7px !important;
}

.swiper-recommendations .swiper-wrapper {
  height: unset !important;
}
</style>
